import { createFileRoute } from "@tanstack/react-router";
import Admin from "@/pages/Admin";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/admin/")({
  head: () => routeHead("/admin/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Admin />
  );
}
